import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect, firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import {
  Col,
  Container,
  ListGroup,
  ListGroupItemHeading,
  Row
} from 'shards-react';
import AddCategories from './AddCategories';
import AddComplaintTypes from './AddComplaintTypes';
import AddSector from './AddSector';
import AddSubCategories from './AddSubCategories';

const mapState = state => ({
  user: state.firebase.profile,
  sectors: state.firebase.ordered.sectors
});

const actions = {};

class SectorsPage extends Component {
  state = {
    sector: ''
  };
  render() {
    const { sectors } = this.props;
    return (
      <Container fluid className='py-2'>
        <ListGroup>
          <strong className='text-danger'>
            Do not use "/" in the entries; use "or" instead.
          </strong>
          <ListGroupItemHeading>
            <strong> Sector & Complaint Types</strong>
          </ListGroupItemHeading>

          <Row>
            <Col>
              <AddSector sectors={sectors} />
            </Col>
            <Col>
              <AddComplaintTypes sector={this.state.sector} />
            </Col>
          </Row>

          <ListGroupItemHeading className='mt-3'>
            <strong> Categories & Sub Categories</strong>
          </ListGroupItemHeading>
          <Row>
            <Col>
              <AddCategories sector={this.state.sector} />
            </Col>
            <Col>
              <AddSubCategories />
            </Col>
          </Row>
        </ListGroup>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect([{ path: '/sectors', queryParams: ['orderByValue'] }]),
  firestoreConnect([
    {
      collection: 'sectors',
      storeAs: 'Firesectors'
    }
  ])
)(SectorsPage);
